// default configuration
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueTheMask from "vue-the-mask";
import vuescroll from "vuescroll";
import VueMoment from "vue-moment";
import "./registerServiceWorker";

// clinicarx external module imports
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import filters from "./filters";
import "@/facades/GlobalFacade";

// clinicarx css imports
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/styles/global.scss";

Vue.config.productionTip = false;

// clinicarx plugin imports
Vue.use(filters);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueTheMask);
Vue.use(vuescroll);
Vue.use(VueMoment);

export const bus = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
